import { Component } from '@angular/core';

@Component({
  selector: 'app-hero-redesign',
  templateUrl: './hero-redesign.component.html',
  styleUrls: ['./hero-redesign.component.scss']
})
export class HeroRedesignComponent {

}
